import { ReportColumnType } from '../../types/report/ReportColumnType';

export const reservationReportColumns = {
    'Customer Name': ReportColumnType.CustomerName,
    'Organization Number': ReportColumnType.CustomerRegistrationNumber,
    'Total Credit': ReportColumnType.ReservationAmount,
    'Available Credit': ReportColumnType.AvailableReservationAmount,
    Currency: ReportColumnType.CurrencyCode,
} as Record<string, ReportColumnType>;
